'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '../utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    hintFormatter?: (values: number[]) => React.ReactNode;
  }
>(({ className, hintFormatter, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      'relative flex w-full touch-none select-none items-center py-2.5',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-quaternary">
      <SliderPrimitive.Range className="absolute h-full bg-brand-600" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="relative block size-6 rounded-full border-2 border-brand-600 bg-white shadow-md ring-offset-white transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
      <span className="absolute left-1/2 top-8 -translate-x-1/2 whitespace-nowrap text-sm font-medium text-tertiary">
        {hintFormatter?.(props.value ?? []) ?? props.value?.[0]}
      </span>
    </SliderPrimitive.Thumb>
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
